import * as React from 'react'
import { ReactElement } from 'react'
import { Field, makeStyles, tokens } from '@fluentui/react-components'
import LocalDatePicker from './LocalDatePicker'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles({
    doubleField: {
        display: 'grid',
        gridTemplateColumns: '50% 50%',
    },
    tripleField: {
        display: 'grid',
        gridTemplateColumns: '33% 33% 34%',
    },
    horizontalMargins: {
        marginLeft: tokens.spacingHorizontalXS,
    },
    verticalMargins: {
        marginTop: tokens.spacingHorizontalXS,
    },
})

export type DateRangeProps = {
    startValue: string
    endValue: string
    changeStartDate: (date: string) => void
    changeEndDate: (date: string) => void
    orientation?: 'vertical' | 'horizontal'
    showLabel?: boolean
    required?: boolean
    validationMessage?: string
}

export default function DateRange(props: DateRangeProps): ReactElement {
    const styles = useStyles()
    const { t: translate } = useTranslation()

    return (
        <Field
            label={props.showLabel && translate('base.daterange')}
            orientation={props.orientation}
            className={props.orientation === 'horizontal' && styles.tripleField}
            required={props.required}
            validationMessage={props.validationMessage}
        >
            <>
                <LocalDatePicker
                    isoValue={props.startValue || null}
                    onSelectDate={props.changeStartDate}
                    // A cleared end date is no upper bound at all, so it has to become undefined rather than an empty
                    // string (HAM-3564).
                    maxDate={props.endValue ? new Date(props.endValue) : undefined}
                    required={props.required || false}
                />
                <LocalDatePicker
                    className={props.orientation === 'horizontal' ? styles.horizontalMargins : styles.verticalMargins}
                    isoValue={props.endValue || null}
                    onSelectDate={props.changeEndDate}
                    minDate={props.startValue ? new Date(props.startValue) : undefined}
                    required={props.required || false}
                />
            </>
        </Field>
    )
}
